import React from "react";
import cx from "clsx";
import { Row, Col } from "react-bootstrap";
import { Header } from "./components/molecules/Header";
import Footer from "./components/molecules/Footer/Footer";
import "./scss/style.scss";
import SalesCard from "./components/organism/SalesCard";
import WorkplaceCard from "./components/organism/WorkplaceCard";
import BackgroundContainer from "./components/molecules/Background/Background";
import styles from "./App.module.scss";

function App() {
  return (
    <>
      <Header />
      <BackgroundContainer childrenContainerClassName="container d-flex align-items-center">
        <Row className={cx(styles.cardContainer, "gx-5 gy-5 mx-auto")}>
          <Col>
            <SalesCard />
          </Col>
          <Col>
            <WorkplaceCard />
          </Col>
        </Row>
      </BackgroundContainer>
      <Footer />
    </>
  );
}

export default App;
